import React, {Fragment} from 'react';
import {Button, Link, Formatted} from 'components';
import {capitalize, config} from 'helpers';

export function WhatsNext() {
  return (
    <Fragment>
      <h1>Congratulations!</h1>
      <Formatted className="spacing">
        <p>You have just completed the first step in your new life journey. By now you should know where you stand today and where you may want to see some change. Now is the time to discover where you want to go from here and how to get there. The next phase of the program will do exactly that.</p>
        <p><Link className="link" to={`/${config.identityModule}/`}>The { capitalize(config.identityModule) } section</Link> will help you discover what brings meaning, significance and happiness into your life, and how to create your own life vision.</p>
        <p><Link className="link" to="/goals/">The Goals section</Link> will help you set meaningful goals and create an action plan that will have real and lasting impact.</p>
        <p><Link className="link" to="/today/">The Today page</Link> will help you stay focused and on track in accomplishing all your goals and aspirations.</p>
        <p className="medium-spacing text-right">
          <Button className="primary" to={`/${config.identityModule}/`} rightIcon="arrow-right">Next</Button>
        </p>
      </Formatted>
    </Fragment>
  );
}
